import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    emoji: {
      textAlign: 'center',
      fontSize: 40,
      borderRadius: 8,
      background: '#ffffff',
      margin: [0, 0, 12, 0],
      padding: [13, 18],
      lineHeight: '40px',

      '&:hover': {
        boxShadow: '0px 4px 16px rgba(17, 18, 54, 0.16)',
        cursor: 'pointer',
        background: '#F6E8F1',
      },
    },
    emojiContent: {
      position: 'relative',
    },
    emojiImg: {
      maxWidth: '42px',
      display: 'inline-block',
      verticalAlign: 'top',
      fontSize: '10px',
      lineHeight: '10px',
    },
    tooltip: {
      position: 'absolute',
      top: '-60px',
      zIndex: 10,
      whiteSpace: 'nowrap',
    },
    tooltipCopy: {
      left: 'calc(50% - 59px)',
    },
    tooltipCopied: {
      left: 'calc(50% - 41px)',
    },
  },
  { name: 'Emojis' },
);
